<template>

<div class="position-fixed top-1 end-1 z-index-2">
  <argon-snackbar
    v-if="snackbar === 'warning'"
    title="Erro ao fazer login!"
    :icon="{ component: 'ni ni-spaceship', color: 'white' }"
    color="danger"
    :close-handler="closeSnackbar"
  />
</div>

  <main class="main-content main-content-bg mt-0">
    <div
      class="page-header min-vh-100"
      style="
        background: black;
      "
    >
      <span class="mask bg-gradient-dark opacity-6"></span>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-7 mt-2">
            <div class="border-0 mb-0">
              <div class="card-header bg-transparent">

                <img class="mx-auto d-block" src="../../../assets/img/iris-hor.png" alt="">

                <h5 class="text-irispay text-center mt-2 mb-3">Acessar painel do parceiro</h5>
              </div>
              <div class="card-body px-lg-5 pt-0">
                <form role="form" class="text-start">
                  <div class="mb-3">
                    <argon-input
                      id="email"
                      type="email"
                      placeholder="Email"
                      aria-label="Email"
                      isRequired
                      @input="loginForm.email = $event.target.value"
                    />
                  </div>
                  <div class="mb-3">
                    <argon-input
                      id="password"
                      type="password"
                      placeholder="Password"
                      aria-label="Password"
                      isRequired
                      @input="loginForm.password = $event.target.value"
                    />
                  </div>

                </form>

                <div class="text-center">
                    <argon-button
                      color="success"
                      variant="gradient"
                      full-width
                      class="my-1 mb-2 btn-irispay"
                      @click="login"
                      >
                        Entrar
                      </argon-button
                    >
                  </div>
                  <div class="text-center">
                    <argon-button
                      color="dark"
                      variant="outline"
                      full-width
                      class="mt-2 mb-4 btn-irispay-outline"
                      @click="resetPassword"
                      >
                        Esqueceu a senha?
                      </argon-button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import api from "@/utils/api.js";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonSnackbar from "@/components/ArgonSnackbar.vue";
import { useRouter } from 'vue-router';
import { mapMutations } from "vuex";

export default {
  name: "SigninBasic",
  components: {
    ArgonInput,
    ArgonButton,
    ArgonSnackbar,
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.toggleDefaultLayout();
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.toggleDefaultLayout();
  },
  methods: {
    ...mapMutations(["toggleDefaultLayout"]),

    login() {

      this.$swal.showLoading()

      api
        .post('/login', this.loginForm)
        .then((response) => {

          this.$swal.close()
          
          console.log("login: ");
          console.log(response.data);

          localStorage.setItem('token', response.data.user.access_token);
          localStorage.setItem('user_type', response.data.user.type);
          localStorage.setItem('user', JSON.stringify(response.data.user));
          this.router.push('/beertap');

        })
        .catch((error) => {

          this.$swal.close()

          this.snackbar = 'warning';

          console.log("erro login: ");
          console.log(error);

        }); 

    },
    closeSnackbar() {
      this.snackbar = null;
    },
    resetPassword(){
      this.router.push('/reset-password');
    }
  },
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      router: useRouter(),
      snackbar: null,
    }
  },
};
</script>
